import { Link } from 'react-router-dom';
import { SparklesIcon } from '@heroicons/react/24/outline';

export default function Navigation() {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-gradient-to-b from-gray-900/80 to-transparent">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-8">
            <Link
              to="/"
              className="flex items-center gap-2 text-xl font-bold text-white hover:text-blue-400 transition-colors group"
            >
              <SparklesIcon className="h-8 w-8 text-blue-500 group-hover:text-blue-400 transition-colors" />
              <span className="bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent">
                NEXON AI
              </span>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
